import { useRef, useState, } from 'react';
import { useNavigate } from 'react-router-dom';
import GeneralButton from '../../mainComponents/generalButton';
import CustomAppBar from '../../mainComponents/appBar';
import ProfileImage from "../../../assets/ProfileImage.png";
import BigTitle from '../../mainComponents/bigTitle';
import { useRegisterMutation } from '../../redux/auth';
import { useDeviceInfo } from '../../hooks/useDeviceInfo';
import { STRINGS } from '../../utils/strings';
import { RegisterRequest } from '../../redux/auth/interface';
import toast from 'react-hot-toast';
import { secureStorageUtils } from '../../utils/secureStorageUtils';


export default function ChooseProfilePicture() {
  const secureStorage = secureStorageUtils;
  const navigate = useNavigate();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const deviceInfo = useDeviceInfo();
  const storedImage = localStorage.getItem("profileImage");

  const [selectedImage, setSelectedImage] = useState<string | null>(() => {
    if (storedImage?.startsWith("blob:")) {
      return null;
    }
    return storedImage;
  });

  const [register, { isLoading }] = useRegisterMutation();
  const [isUploading, setIsUploading] = useState(false);



  const openFilePicker = () => {
    fileInputRef.current?.click();
  };

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Image = reader.result as string;
        setSelectedImage(base64Image);
        localStorage.setItem("profileImage", base64Image);

      };
      reader.readAsDataURL(file);
    }
  };

  async function handleContinue(skip: boolean ): Promise<void> {
   
    const existingPayload = JSON.parse(localStorage.getItem(STRINGS.LOCAL_STORAGE_KEY) || "{}") as RegisterRequest;

    if (!existingPayload) {
      toast.error("No existing payload found in localStorage.");
      console.error("No existing payload found in localStorage.");
      return;
    }

    // Make picture compulsory unless skipping
    if (!skip && !selectedImage) {
      toast.error("Please select a profile picture to continue.");
      return;
    }

    // Set loading state when picture is selected
    if (!skip && selectedImage) {
      setIsUploading(true);
    }

    let profilePicture = "";
    /// save selectedImage to cloudinary
    if (skip == false) {
      if (selectedImage) {
        try {
          const formData = new FormData();
          formData.append('file', selectedImage);
          formData.append('upload_preset', STRINGS.UPLOAD_PRESET || '');

          const cloudinaryResponse = await fetch(
            `https://api.cloudinary.com/v1_1/${STRINGS.CLOUD_NAME}/image/upload`,
            {
              method: 'POST',
              body: formData,
            }
          );

          const data = await cloudinaryResponse.json();
          if (data.secure_url) {
            profilePicture = data.secure_url;
          } else {
            toast.error("Failed to upload profile image.");
            console.error("Cloudinary upload error:", data);
            setIsUploading(false);
            return;
          }
        } catch (error) {
          toast.error("Error uploading image to Cloudinary.");
          console.error("Cloudinary error:", error);
          setIsUploading(false);
          return;
        }
        console.log("selectedImage");
      }
    }
    // end /// save selectedImage to cloudinary
    // console.log(selectedImage);
    // console.log(profilePicture);
    const registerRequest = {
      profilePicture: profilePicture,
      age: existingPayload.age,
      username: existingPayload.username,
      platform: existingPayload.platform || "instagram",
      userAgent: deviceInfo.userAgent,
      deviceName: deviceInfo.deviceName,
      deviceIP: deviceInfo.deviceIP,
      deviceMacAddress: deviceInfo.deviceMacAddress,
    };

    // console.log("Registering with payload:", registerRequest);

    try {
      const response = await register(registerRequest).unwrap();
      console.log("Registration successful:", response);

      let token: string | undefined;
      if (response?.data) {
        token = response.data;
        if (token) {
          secureStorage.setItem("access-token", token);
        }
      }

      localStorage.removeItem("register-payload");
      localStorage.removeItem("ngl-registration-data");

      navigate("/play", { state: { profileImage: selectedImage } });
    } catch (error) {
      toast.error("Registration failed. Please try again.");
      console.error("Registration failed:", error);
      setIsUploading(false);
    }
  }


  return (
    <div className="flex flex-col items-center justify-center pt-10 h-screen overflow-hidden bg-[#1a2630] text-white p-5 font-custom">
      {/* <CustomAppBar
        suffix={
          <button
            onClick={() => handleContinue(true)}
            className="text-white text-xl font-bold"
          >
            Skip
          </button>
        }
      /> */}

      <div className="pt-24 text-center">
        <BigTitle text={'Choose a'} />
        <BigTitle text={'profile picture'} />
      </div>

      <div className="relative my-10">
        <div className="w-[150px] h-[150px] rounded-full border-4 border-[#6d7680a9] p-1 flex items-center justify-center overflow-hidden">
          <div className="bg-[#6d7680a9] w-full h-full flex items-center justify-center rounded-full">
            <img
              src={selectedImage || ProfileImage}
              className="w-full h-full object-cover"
              alt="."
            />
          </div>
        </div>

        <label
          onClick={openFilePicker}
          className="absolute bottom-3 right-3 w-8 h-8 bg-white border border-gray-300 rounded-full flex items-center justify-center cursor-pointer shadow"
        >
          <span className="text-gray-600 text-[30px] font-semibold leading-none">
            +
          </span>
        </label>

        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleImageChange}
          className="hidden"
        />
      </div>

      <GeneralButton
        text={isLoading || isUploading ? 'Loading...' : 'Continue'}
        color={'white'}
        onClick={() => handleContinue(false)}
        disabled={isLoading || isUploading}
      />

      <div className="h-10" />
    </div>
  );
}
